import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Facebook, Twitter, Instagram, Heart } from 'lucide-react';
import BubbleCareLogo from './BubbleCareLogo';

const Footer: React.FC = () => {
  const footerLinks = [
    {
      title: "Services",
      links: [
        { name: "Home Care", href: "/services" },
        { name: "Cleaning", href: "/services" },
        { name: "Grocery Shopping", href: "/services" },
        { name: "Gardening", href: "/services" },
        { name: "Companionship", href: "/services" }
      ]
    },
    {
      title: "Company",
      links: [
        { name: "About Us", href: "#" },
        { name: "How It Works", href: "#" },
        { name: "Careers", href: "#" },
        { name: "Blog", href: "#" },
        { name: "Contact", href: "#" }
      ]
    },
    {
      title: "Support",
      links: [
        { name: "Help Center", href: "#" },
        { name: "Safety", href: "#" },
        { name: "Terms of Service", href: "#" },
        { name: "Privacy Policy", href: "#" },
        { name: "Cookies", href: "#" }
      ]
    }
  ];

  const socialLinks = [
    { icon: <Facebook size={20} />, href: "#" },
    { icon: <Twitter size={20} />, href: "#" },
    { icon: <Instagram size={20} />, href: "#" }
  ];

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="container-custom pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          <div className="lg:col-span-2">
            <div className="mb-4">
              <BubbleCareLogo size="md" />
            </div>
            <p className="text-muted-foreground mb-6 max-w-md text-balance">
              Connecting families with trusted caregivers and local volunteers to ensure their loved ones receive the best possible care at home.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((link, index) => (
                <motion.a
                  key={index}
                  href={link.href}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  className="w-10 h-10 rounded-full bg-tech-50 flex items-center justify-center text-tech-600 transition-colors hover:bg-tech-100"
                >
                  {link.icon}
                </motion.a>
              ))}
            </div>
          </div>

          {footerLinks.map((group, idx) => (
            <div key={idx}>
              <h3 className="font-semibold text-tech-800 mb-4">{group.title}</h3>
              <ul className="space-y-3">
                {group.links.map((link, index) => (
                  <li key={index}>
                    <Link 
                      to={link.href} 
                      className="text-muted-foreground hover:text-tech-700 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
          <p className="text-muted-foreground text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} BubbleCare. All rights reserved.
          </p>
          <p className="text-muted-foreground text-sm flex items-center">
            Made with <Heart className="h-4 w-4 text-tech-500 mx-1" /> for families and caregivers
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
